import {combine} from 'effector';
import {createGate} from 'effector-react';

import {fetchOriginalPhoto, fetchProductsDetail} from 'api/products';
import {RestError} from 'core/errors';
import {createGridTableModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';
import {ProductCommonRaw, ProductOperationsRawRow, ProductTracing} from 'types/products-detail';

const domain = rootDomain.createDomain('ProductsDetailDomain');
export const Gate = createGate<{markingCode: string; gtin: string | null}>('ProductsDetailGate');
export const OriginalPhotoGate = createGate<{link: string}>('ProductsOriginalPhotoGate');

export const {
    filters$,
    filtersChanged,
    filtersReset,
    defaultFilters,
    stateReset,
} = createGridTableModel({
    domain,
    Gate,
});

export const fetchDataFx = domain.createEffect({
    name: 'fetchCommonDataFx',
    handler: fetchProductsDetail,
});

export const fetchOperationsDataFx = domain.createEffect({
    name: 'fetchOperationsDataFx',
    handler: fetchProductsDetail,
});

export const fetchOriginalPhotoFx = domain.createEffect({
    name: 'fetchOriginalPhotoFx',
    handler: fetchOriginalPhoto,
});

export const commonData$ = domain.createStore<ProductCommonRaw | null>(null);
export const operationsData$ = domain.createStore<ProductOperationsRawRow[]>([]);

export const codeTracingData$ = domain.createStore<{
    operations: ProductOperationsRawRow[];
    tracing: ProductTracing[];
} | null>(null);

export const error$ = domain.createStore<RestError | null>(null);
export const childrenTotalCount$ = commonData$.map((data) => data?.childrenTotalCount || 0);

export const originalPhoto$ = domain.createStore<string | null>(null);
export const originalPhotoError$ = domain.createStore<boolean>(false);

export const commonDataState$ = combine({
    data: commonData$,
    error: error$,
    isLoading: fetchDataFx.pending,
});

export const operationsTableState$ = combine({
    data: operationsData$,
    filters: filters$,
    error: error$,
    isLoading: fetchOperationsDataFx.pending,
});

export const codeTracingState$ = combine({
    data: codeTracingData$,
    error: error$,
    isLoading: fetchDataFx.pending,
});

export const originalPhotoState$ = combine({
    photo: originalPhoto$,
    error: originalPhotoError$,
    isLoading: fetchOriginalPhotoFx.pending,
});
